import { Space, Typography } from '@sravni/react-design-system';
import cn from 'classnames';

import { getCircleProgress } from 'shared/ui/CircleProgress/lib/getProgress';

import { CIRCLE_CONFIG, CircleProgressConfig } from '../CircleProgress.config';

import styles from './CircleProgress.module.scss';

interface RatingProps {
  value: number;
  circumference?: number;
  maxValue: number;
  statusBarClassName?: string;
  size?: 'small' | 'medium';
}

export const CircleProgress: FC<RatingProps> = ({
  size = 'medium',
  className,
  statusBarClassName,
  value,
  circumference = CIRCLE_CONFIG.CIRCUMFERENCE,
  maxValue,
}) => {
  const { circleSize, valueFontSize } = CircleProgressConfig[size];

  return (
    <Space
      align="center"
      justify="center"
      className={cn(className, styles.container)}
    >
      <svg
        className={styles.circle}
        width={circleSize}
        height={circleSize}
        viewBox="0 0 50 50"
      >
        <circle
          className={styles.emptyBar}
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke="white"
        />
        <circle
          className={cn(styles.statusBar, statusBarClassName)}
          cx="25"
          cy="25"
          r="20"
          fill="none"
          strokeDasharray={`${circumference} ${circumference}`}
          strokeDashoffset={getCircleProgress(value, maxValue) * circumference}
          stroke="currentColor"
        />
      </svg>

      <Space
        className={size === 'medium' ? styles.textMedium : styles.textSmall}
        direction="vertical"
        align="center"
      >
        <Typography.Text
          size={valueFontSize}
          strong
        >
          {value || 0}
        </Typography.Text>
      </Space>
    </Space>
  );
};
